import { create } from 'zustand'
import { combine, persist } from 'zustand/middleware'

import {
  resetDashboardStoreAction,
  setSelectedGroupIdAction,
} from '@/features/ui/pages/dashboard/stores/dashboard/dashboard.actions'
import subscribeToStore from '@/lib/zustand'

export type DashboardStoreValuesType = {
  selectedGroupId: string | null
}

export const INITIAL_DASHBOARD_STORE_VALUES: DashboardStoreValuesType = {
  selectedGroupId: null,
}

export const DASHBOARD_STORAGE_KEY = 'dashboard'

const dashboardStore = subscribeToStore(
  create(
    persist(
      combine(INITIAL_DASHBOARD_STORE_VALUES, (set, get) => ({
        setSelectedGroupId: (groupId: string | null) => setSelectedGroupIdAction(set, groupId),
        reset: () => resetDashboardStoreAction(set),
      })),
      {
        name: DASHBOARD_STORAGE_KEY,
      },
    ),
  ),
)

export default dashboardStore
